<template>
  <div class="footer-navbar px-4 py-3">
    <v-layout wrap>
      <v-flex
        xs12
        sm10
        md10>
        <ul class="contentinfo list--none d-inline-block">
          <li class="d-inline-block pr-4">
            <span class="font-weight-bold">&copy; 2017-{{ new Date().getFullYear() }} Kontinentalist</span>
          </li>

          <li class="d-inline-block pr-4">
            <address>284 River Valley Rd Singapore 238325</address>
          </li>

          <li class="d-inline-block pr-4">
            <a href="mailto:hello@kontinentalist.com" class="primary--text">hello@kontinentalist.com</a>
          </li>
        </ul>

        <ul class="nav-links list--none d-inline-block">
          <li
            v-for="item in navItems"
            :key="item.title"
            class="d-inline-block pr-4">

            <a :href="`https://kontinentalist.com${item.link}`">{{ item.title }}</a>
          </li>
        </ul>
      </v-flex>

      <v-flex
        xs12
        sm2
        md2
        text-md-right>

        <ul class="social-links list--none">
          <li
            v-for="item in socialItems"
            :key="item.href"
            class="d-inline-block">

            <a :href="item.href" target="_blank">
              <fa-icon :icon="['fab', item.icon]" fixed-width />
            </a>
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        { title: 'About us', link: '/about' },
        { title: 'Careers', link: '/careers' },
        { title: 'Terms', link: '/terms-of-service' },
        { title: 'Privacy', link: '/privacy-policy' },
        { title: 'Contact Us', link: '/contact' },
      ],
      socialItems: [
        { href: 'https://www.facebook.com/kontinentalistsg', icon: 'facebook-f' },
        { href: 'https://www.instagram.com/kontinentalist', icon: 'instagram' },
        { href: 'https://medium.com/kontinentalist', icon: 'medium' },
      ],
    };
  },
};
</script>

<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_variables';

.footer-navbar {
  border-top: solid 1px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  width: 100%;

  .nav-links {
    a {
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .social-links {
    a {
      color: #000;
    }
  }

  @media $display-breakpoints.xs-only {
    .contentinfo {
      margin-bottom: 24px;

      li {
        margin-bottom: 16px;
      }
    }

    .nav-links {
      margin-bottom: 16px;

      li {
        margin-bottom: 8px;
        display: block !important;
      }
    }
  }
}
</style>
